import { ChevronDown } from 'lucide-react'
import { Link } from 'react-router-dom'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { BreadcrumbItem } from '../types'

interface BreadcrumbMobileProps {
  previousItems: BreadcrumbItem[]
  lastItem: BreadcrumbItem
}

export function BreadcrumbMobile({ previousItems, lastItem }: BreadcrumbMobileProps) {
  return (
    <div className="sm:hidden flex items-center gap-1">
      {previousItems.length > 0 ? (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button
              type="button"
              className="flex items-center gap-1 px-2 py-1 text-sm text-gray-600 hover:text-gray-900 transition-colors rounded"
            >
              <ChevronDown className="w-4 h-4" />
              <span className="truncate">{lastItem.label}</span>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start">
            {previousItems.map((item, index) => (
              <DropdownMenuItem key={index} asChild>
                {item.href ? (
                  <Link to={item.href} className="w-full">
                    {item.label}
                  </Link>
                ) : (
                  <span>{item.label}</span>
                )}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      ) : (
        <span className="flex items-center gap-1 px-2 text-sm text-gray-900 font-semibold min-w-0">
          <span className="truncate">{lastItem.label}</span>
        </span>
      )}
    </div>
  )
}
